"use client";

// components
import HeroSection from "@/components/HeroSection ";
import ProductNavigationTabs from "@/components/ProductNavigationTabs";
import BusSearchFormWrapper from "@/components/pages/bus/searchForm";
import { getCdnImagePath } from "@/utils/bus/getCdnImagePath";

// utils
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { getPassengerTypeBreakdownVisibility } from "@/utils/bus/appConfigUtils";
import clsx from "clsx";

const HeaderSection = ({
  isNavigation = true,
  mainTitle,
  customTitle,
  customMobileTitle,
  titleClassName = "",
  mobileTitleClassName = "",
  backgroundWrapperClassName,
  backgroundImageClassName,
  backgroundImage = null,
  wrapperClassName = "",
  contentClassName = "",
  searchFormInitialData = {},
  hasHeaderNavigation = false,
}) => {
  const showPassengerTypeBreakdown = getPassengerTypeBreakdownVisibility();

  const t = useTranslationDetector("bus");

  // Search component'ini initial data ile wrap et
  const SearchComponentWithData = (props) => (
    <BusSearchFormWrapper
      searchButtonTextClassName="inline md:hidden xl:inline"
      searchButtonTurnaIconClassName="!inline-block md:!hidden xl:!block"
      searchButtonMagnifierIconClassName="!hidden md:!inline-block xl:!hidden"
      leftSideContentWrapperClassname={clsx(
        showPassengerTypeBreakdown
          ? "md:w-[55%] lg:w-[55%] xl:w-[60%]"
          : "md:w-[62%]",
      )}
      rightSideContentWrapperClassname={clsx(
        showPassengerTypeBreakdown
          ? "md:w-[45%] lg:w-[45%] xl:w-[40%]"
          : "md:w-[38%]",
      )}
      {...searchFormInitialData}
      {...props}
    />
  );

  return (
    <HeroSection
      hasHeaderNavigation={hasHeaderNavigation}
      contentClassName={contentClassName}
      className={wrapperClassName}
      titleClassName={titleClassName}
      mobileTitleClassName={mobileTitleClassName}
      mainTitle={mainTitle}
      title={
        customTitle || (
          <>
            {t("heroTitleLine1")}
            <br />
            {t("heroTitleLine2")}
          </>
        )
      }
      mobileTitle={customMobileTitle || t("heroMobileTitle")}
      navigationComponent={isNavigation && ProductNavigationTabs}
      searchComponent={SearchComponentWithData}
      backgroundImage={
        backgroundImage || {
          desktop: getCdnImagePath("/saka/bus/desktop-background.png"),
          tablet: getCdnImagePath("/saka/bus/desktop-background-small.png"),
          mobile: getCdnImagePath("/saka/bus/desktop-background.png"),
        }
      }
      backgroundWrapperClassName={backgroundWrapperClassName}
      backgroundImageClassName={backgroundImageClassName}
    />
  );
};

export default HeaderSection;
